import {
  EventGroup,
  MixpanelEvent,
  WebPageViewApplication,
} from "@flowstepdesign/shared";
import { createRouter } from "@tanstack/react-router";

import { trackEvent } from "@/analytics/tracking";

// Import the generated route tree
import { routeTree } from "./routeTree.gen";

export type RouterContext = {
  request?: Request;
};

// Create a new router instance
export const getRouter = () => {
  const router = createRouter({
    routeTree,
    context: { request: undefined } satisfies RouterContext,

    scrollRestoration: true,
    defaultPreloadStaleTime: 0,
  });

  // Tracks initial page load and subsequent route changes
  router.subscribe("onRendered", () => {
    if (typeof window !== "undefined") {
      trackEvent(MixpanelEvent.WebPageViewed, {
        event_group: EventGroup.WebPageView,
        application: WebPageViewApplication.Copilot,
        // user_id: userId, // TODO: Add `userId` to track user identity. `userId` can be undefined for non logged-in users
        current_page_title: document.title,
        current_domain: window.location.hostname,
        current_url_path: window.location.pathname,
        current_url_protocol: window.location.protocol,
        current_url_search: window.location.search,
      });
    }
  });

  return router;
};
